import { CREATE_ORDER_FAILURE, CREATE_ORDER_REQUEST, CREATE_ORDER_SUCCESS } from './ActionType'
import { api } from "../../config/apiConfig";
// export const createOrder = (reqData) => async (dispatch) => {
//     // console.log(reqData);
//     dispatch({ type: CREATE_ORDER_REQUEST })
//     try {
//         const { data } = api.post(`products/order`, reqData)
//         localStorage.removeItem('cartItems')
//         localStorage.removeItem('totalQuantity')
//         localStorage.removeItem('totalAmount')
//         dispatch({ type: CREATE_ORDER_SUCCESS, payload: data, });
//     } catch (error) {
//         dispatch({ type: CREATE_ORDER_FAILURE, payload: error.message })
//     }
// }

export const createOrder = (reqData, navigate) => async (dispatch) => {
    dispatch({ type: CREATE_ORDER_REQUEST })

    try {
        const { data } = await api.post(`products/order`, reqData)

        localStorage.removeItem('cartItems')
        localStorage.removeItem('totalQuantity')
        localStorage.removeItem('totalAmount')

        dispatch({ type: CREATE_ORDER_SUCCESS, payload: data })

        //  navigate("/xac-nhan-don-hang.html")

    } catch (error) {
        dispatch({ type: CREATE_ORDER_FAILURE, payload: error.message })
    }
}